(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["povec-tech-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateProgress = (component, swiper) => {
      const fill = component.querySelector('.povec-tech-features__progress-fill');
      if (!fill) return;
      const total = Math.max(swiper.snapGrid.length, 1);
      const current = Math.min((swiper.snapIndex || 0) + 1, total);
      fill.style.transformOrigin = getComputedStyle(component).direction === 'rtl' ? 'right center' : 'left center';
      fill.style.transform = `scaleX(${current / total})`;
    };

    const initialize = (component) => {
      if (!window.Swiper || component.dataset.initialized === 'true') return;
      const carousel = component.querySelector('.povec-tech-features__carousel');
      if (!carousel) return;
      component.dataset.initialized = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const swiper = new window.Swiper(carousel, {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 8,
        speed: reducedMotion ? 0 : 500,
        // Keep both direct touch dragging and trackpad two-finger horizontal gestures enabled.
        allowTouchMove: true,
        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
        threshold: 5,
        grabCursor: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 0.8,
        },
        watchOverflow: true,
        navigation: {
          prevEl: component.querySelector('.povec-tech-features__control--prev'),
          nextEl: component.querySelector('.povec-tech-features__control--next'),
        },
        breakpoints: {
          769: {
            spaceBetween: 32,
            slidesPerGroup: 2,
          },
        },
        on: {
          init(instance) {
            updateProgress(component, instance);
          },
          progress(instance) {
            updateProgress(component, instance);
          },
          slideChange(instance) {
            updateProgress(component, instance);
          },
          snapIndexChange(instance) {
            updateProgress(component, instance);
          },
          resize(instance) {
            updateProgress(component, instance);
          },
        },
      });

      component.povecTechFeaturesSwiper = swiper;
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-povec-tech-features]').forEach(initialize);
    };

    const start = () => {
      if (window.Swiper) initializeAll();
      else window.addEventListener('load', () => initializeAll(), { once: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('.povec-tech-features__card');
      const component = slide && slide.closest('[data-povec-tech-features]');
      if (!slide || !component?.povecTechFeaturesSwiper) return;
      component.povecTechFeaturesSwiper.slideTo(Array.from(slide.parentElement.children).indexOf(slide));
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-povec-tech-features]').forEach((component) => {
        component.povecTechFeaturesSwiper?.destroy(true, true);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["povec-tech-story-active"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('.povec-tech-story-active:not([data-initialized])').forEach((section) => {
        const panels = [...section.querySelectorAll('[data-panel]')];
        if (panels.length !== 2) return;

        section.dataset.initialized = 'true';
        let current = 0;

        const showPanel = (index) => {
          current = (index + panels.length) % panels.length;
          panels.forEach((panel, panelIndex) => {
            const active = panelIndex === current;
            panel.classList.toggle('is-active', active);
            panel.setAttribute('aria-hidden', String(!active));
            panel.inert = !active;
          });
        };

        showPanel(0);
        section.classList.add('is-ready');

        section.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            const direction = Number(button.dataset.direction);
            showPanel(current + direction);
          });
        });

        section.addEventListener('shopify:block:select', () => showPanel(1));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["povec-tech-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (component) => {
      const sectionElement = component.closest('.shopify-section');
      const timeline = component && component.querySelector('[data-timeline]');
      const spacer = sectionElement && sectionElement.querySelector('[data-timeline-spacer]');
      const startSentinel = sectionElement && sectionElement.querySelector('[data-timeline-start]');
      if (!component || !timeline || component.dataset.initialized === 'true') return;
      component.dataset.initialized = 'true';

      const cardTrack = timeline.querySelector('.povec-tech-timeline__items');
      const items = Array.from(timeline.querySelectorAll('[data-timeline-item]'));
      const titles = items.map((item) => item.querySelector('[data-timeline-title]'));
      const mediaItems = Array.from(component.querySelectorAll('[data-timeline-media-item]'));
      if (!items.length) return;

      let frameRequested = false;
      let animationFrame = 0;
      let pageScrollBound = false;
      let mobileSwiper = null;
      const mobileQuery = window.matchMedia('(max-width: 768.98px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const { signal } = controller;

      const isMobile = () => mobileQuery.matches;

      const updateStickyTop = () => {
        if (isMobile()) {
          component.style.removeProperty('--timeline-sticky-top');
          return;
        }

        const headerHeight = parseFloat(getComputedStyle(component).getPropertyValue('--header-height')) || 0;
        const availableHeight = Math.max(window.innerHeight - headerHeight, 0);
        const centeredOffset = Math.max((availableHeight - component.offsetHeight) / 2, 0);
        component.style.setProperty('--timeline-sticky-top', `${headerHeight + centeredOffset}px`);
      };

      const setActive = (index) => {
        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;
          item.classList.toggle('is-active', isActive);
          if (isActive) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
        });
        mediaItems.forEach((mediaItem, itemIndex) => {
          const isActive = itemIndex === index;
          mediaItem.classList.toggle('is-active', isActive);
          mediaItem.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      const updateMobileProgress = (swiper) => {
        const total = Math.max(swiper.slides.length, 1);
        const swiperProgress = Math.min(Math.max(swiper.progress, 0), 1);
        const progress = total > 1 ? (1 + swiperProgress * (total - 1)) / total : 1;
        timeline.style.setProperty('--timeline-mobile-progress', progress);
      };

      const update = () => {
        frameRequested = false;
        if (isMobile()) return;

        const stickyTop = parseFloat(getComputedStyle(component).top) || 0;
        const pinDistance = spacer ? spacer.getBoundingClientRect().height : 0;
        const startPosition = startSentinel
          ? window.scrollY + startSentinel.getBoundingClientRect().top - stickyTop
          : window.scrollY;
        const pinProgress =
          pinDistance > 0 ? Math.min(Math.max((window.scrollY - startPosition) / pinDistance, 0), 1) : 0;

        const timelineRect = timeline.getBoundingClientRect();
        const progress = timelineRect.height * pinProgress;
        timeline.style.setProperty('--timeline-progress', progress + 'px');

        let nextIndex = 0;
        titles.forEach((title, index) => {
          if (!title) return;
          const titlePosition = title.getBoundingClientRect().top - timelineRect.top;
          if (titlePosition <= progress) nextIndex = index;
        });
        setActive(nextIndex);
      };

      const requestUpdate = () => {
        if (frameRequested) return;
        frameRequested = true;
        animationFrame = requestAnimationFrame(update);
      };

      const initializeMobileSwiper = () => {
        if (!isMobile() || mobileSwiper || !window.Swiper) return;

        timeline.classList.add('swiper');
        cardTrack.classList.add('swiper-wrapper');
        items.forEach((item) => item.classList.add('swiper-slide'));
        timeline.setAttribute('role', 'region');
        timeline.setAttribute(
          'aria-label',
          component.querySelector('.povec-tech-timeline__heading')?.innerText.trim() ||
            titles[0]?.innerText.trim() ||
            ''
        );

        mobileSwiper = new window.Swiper(timeline, {
          slidesPerView: 'auto',
          spaceBetween: 20,
          speed: reducedMotionQuery.matches ? 0 : 500,
          watchOverflow: true,
          on: {
            init(instance) {
              updateMobileProgress(instance);
            },
            progress(instance) {
              updateMobileProgress(instance);
            },
            resize(instance) {
              updateMobileProgress(instance);
            },
          },
        });
      };

      const destroyMobileSwiper = () => {
        if (mobileSwiper) {
          mobileSwiper.destroy(true, true);
          mobileSwiper = null;
        }
        timeline.classList.remove('swiper');
        cardTrack.classList.remove('swiper-wrapper');
        items.forEach((item) => item.classList.remove('swiper-slide'));
        timeline.removeAttribute('role');
        timeline.removeAttribute('aria-label');
      };

      const setPageScrollBinding = (shouldBind) => {
        if (shouldBind === pageScrollBound) return;
        pageScrollBound = shouldBind;
        if (shouldBind) {
          window.addEventListener('scroll', requestUpdate, { passive: true, signal });
        } else {
          window.removeEventListener('scroll', requestUpdate);
        }
      };

      const resize = () => {
        if (isMobile()) {
          updateStickyTop();
          mobileSwiper?.update();
          if (mobileSwiper) updateMobileProgress(mobileSwiper);
          return;
        }
        updateStickyTop();
        requestUpdate();
      };

      const updateMode = () => {
        if (isMobile()) {
          updateStickyTop();
          setPageScrollBinding(false);
          initializeMobileSwiper();
        } else {
          destroyMobileSwiper();
          updateStickyTop();
          setPageScrollBinding(true);
          requestUpdate();
        }
      };

      window.addEventListener('resize', resize, { signal });
      mobileQuery.addEventListener('change', updateMode, { signal });
      sectionElement.addEventListener(
        'shopify:block:select',
        (event) => {
          if (!isMobile()) return;
          const index = items.findIndex((item) => item === event.target || item.contains(event.target));
          if (index >= 0 && mobileSwiper) mobileSwiper.slideTo(index, 0);
        },
        { signal }
      );
      sectionElement.addEventListener(
        'shopify:section:unload',
        () => {
          controller.abort();
          destroyMobileSwiper();
          cancelAnimationFrame(animationFrame);
        },
        { once: true, signal }
      );
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (!signal.aborted) resize();
        });
      }
      if (!window.Swiper) {
        window.addEventListener(
          'load',
          () => {
            if (!signal.aborted) updateMode();
          },
          { once: true, signal }
        );
      }
      updateMode();
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-povec-tech-timeline]').forEach(initialize);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
